import axios from 'axios';

// TODO: Add additional axios config here if needed
axios.defaults.withCredentials = true;
axios.defaults.baseURL = '/api/';

export default axios;
